<template>
	<div class="report-container">
		<!-- 主体视界 -->
		<main class="content-main">
			<!-- 1. 欢迎语标题（姓名做高级渐变突出） -->
			<section class="welcome-title-group">
				<h1 class="welcome-text">
					Hi ~
					<span class="user-name-gradient">{{ ReportData.stuname }}</span>
					，<br />
					我们又见面啦 <span class="wave-hand">✨</span>
				</h1>
			</section>

			<!-- 2. 100%保留完整散文文案（错落诗歌排版，拒绝大白框） -->
			<section v-if="ReportData.studate" class="story-body-flow">
				<!-- 第一段：时间流逝 -->
				<div class="text-phrase slide-in-1">
					<p class="story-line highlight-time" style="font-size: 20px">
						2026年10月｜步履有痕
					</p>
					<p class="story-line">秋意渐隐，冬序初开。</p>
					<p class="story-line">你在流转的时光里，</p>
					<p v-show="ReportData.studate" class="story-line font-bold-teal">
						静心走过
						<span class="font-bold-orange highlight-time">{{
							ReportData.studate
						}}</span>
						个晴朗的日子。
					</p>
					<p v-show="ReportData.playtime" class="story-line font-bold-teal">
						<span class="font-bold-orange highlight-time">{{
							ReportData.playtime
						}}</span>
						小时倾听内心的回响，
					</p>
					<p v-show="ReportData.playtime" class="story-line font-bold-teal">
						在<span class="font-bold-orange highlight-time">{{
							ReportData.coursenumMon
						}}</span>
						门课程间拓宽眼界，
					</p>
					<p v-show="ReportData.playtime" class="story-line font-bold-teal">
						点亮<span class="font-bold-orange highlight-time">{{
							ReportData.coursenum
						}}</span>
						座学识的灯塔，
					</p>
					<p v-show="ReportData.playtime" class="story-line font-bold-teal">
						通过<span class="font-bold-orange highlight-time">{{
							ReportData.examTimes
						}}</span>
						次试炼，
					</p>
					<p v-show="ReportData.creditvalue" class="story-line">
						握紧<span class="font-bold-orange highlight-time">{{
							ReportData.creditvalue
						}}</span>
						点闪耀的星光。
					</p>
					<p class="story-line">万物收敛藏实，</p>
					<p class="story-line">你所积攒的每一份底气，</p>
					<p class="story-line">都在静候春山可望。</p>
				</div>
			</section>
			<section v-else class="story-body-flow">
				<!-- 第一段：时间流逝 -->
				<div class="text-phrase slide-in-1">
					<p class="story-line highlight-time" style="font-size: 20px">
						2026年10月｜步履有痕
					</p>
					<p class="story-line">秋意渐隐，冬序初开。</p>					
					<p class="story-line">万物收敛藏实，</p>
					<p class="story-line">你所积攒的每一份底气，</p>
					<p class="story-line">都在静候春山可望。</p>
					<p class="story-line">2026年10月，你还没开始学习。请继续加油！</p>
				</div>
			</section>

			<!-- 3. 底部动态引导组件 -->
			<section class="footer-guide-section fade-in-up">
				<!-- <p class="guide-main-text">十月的学习报告已为你生成</p> -->
				<div class="swipe-hint-box">
					<span class="swipe-finger">👈</span>
					<span class="guide-sub-text">左滑查看更多内容 ~</span>
				</div>
			</section>
		</main>

		<!-- 底部微光朦胧光环装饰 -->
		<!-- <div class="ambient-glow-ball"></div> -->
	</div>
</template>

<script>
export default {
	props: ["ReportData"],
};
</script>

<style scoped>
/* 年度报告风格 · 暖秋风格优化 */
.report-container {
	position: relative;
	width: 100%;
	height: 100vh;
	overflow: hidden;
	box-sizing: border-box;
	padding: 35px 28px;
	background: url("../../assets/26June/logo.png") right top no-repeat,
		url("../../assets/26October/bg.png") no-repeat center / cover;
	background-size: 100px 32px, cover;
	background-color: #f7ede2;
	font-family: -apple-system, "SF Pro Text", "PingFang SC", "Helvetica Neue",
		sans-serif;
	/* 移除原先导致文字发虚的浅色 text-shadow */
}

/* 主体容器弹性分布 */
.content-main {
	position: relative;
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 10px 0 10px 0;
	z-index: 2;
}

/* 1. 欢迎标题区 */
.welcome-title-group {
	animation: fadeInDown 0.8s cubic-bezier(0.16, 1, 0.3, 1);
	/* margin-top: 15px; */
}

.welcome-text {
	/* padding-left: 20px; */
	text-align: center;
	font-size: 27px;
	font-weight: 800;
	line-height: 1.4;
	color: #2c180b;
	/* 主标题：深咖啡色，清晰醒目 */
	margin: 0;
	letter-spacing: 1px;
}

/* 名字高亮渐变 */
.user-name-gradient {
	color: #dc7234;
	/* 琥珀暖橙色，完美融合秋季主题 */
	font-weight: 900;
	font-size: 30px;
	text-shadow: -1.5px -1.5px 0 #fff, 1.5px -1.5px 0 #fff, -1.5px 1.5px 0 #fff,
		1.5px 1.5px 0 #fff;
}

.wave-hand {
	display: inline-block;
	animation: wave 2.5s ease-in-out infinite;
	transform-origin: 70% 70%;
}

/* 2. 散文流 */
.story-body-flow {
	display: flex;
	flex-direction: column;
	gap: 5px;
	margin-top: 4px;
	/* padding-left: 20px; */
}

.text-phrase {
	position: relative;
	background: rgba(222, 219, 216, 0.65);
	border: 1px solid rgba(217, 107, 24, 0.12);
	border-radius: 12px 20px 10px 18px / 18px 10px 20px 12px;
	padding: 12px 18px;
	box-shadow: 0 4px 18px rgba(80, 40, 15, 0.08);
	backdrop-filter: blur(2px);
}

.pad-left-b {
	/* padding-left: 16px; */
}

.story-line {
	font-size: 20px;
	line-height: 1.6;
	margin: 0 0 4px 0;
	color: #3d2314;
	/* 正文：浓郁深褐色，保证对比度 */
	letter-spacing: 1px;
	font-weight: 500;
}

.story-line:last-child {
	margin-bottom: 0;
}

/* 局部文案高亮 */
.highlight-time {
	color: #dc7234;
	/* 原蓝色替换为深咖啡色 */
	font-weight: 700;
	text-shadow: -1.5px -1.5px 0 #fff, 1.5px -1.5px 0 #fff, -1.5px 1.5px 0 #fff,
		1.5px 1.5px 0 #fff;
}

.font-bold-teal {
	color: #2c180b;
	/* 原蓝色替换为深褐色，加重强调 */
	font-weight: 800;
}

.font-bold-orange {
	/* display: inline-block; */
	color: #db6018;
	font-size: 20px;
	/* background: rgba(240, 200, 140, 0.35); */
	/* border: 1px solid rgba(217, 107, 24, 0.2); */
	font-weight: 800;
	padding: 0 12px 2px 8px;
	border-radius: 4px 12px 3px 10px / 10px 3px 12px 4px;
	text-shadow: -1.5px -1.5px 0 #fff, 1.5px -1.5px 0 #fff, -1.5px 1.5px 0 #fff,
		1.5px 1.5px 0 #fff;
}

.strong-dark {
	color: #2c180b;
	font-weight: 800;
	font-size: 19px;
	letter-spacing: 2px;
}

/* 3. 底部滑动提示 */
.footer-guide-section {
	text-align: center;
	margin-bottom: 10px;
	margin-top: 10px;
	/* background: rgba(247, 237, 226, 0.65); */
	border: 1px solid rgba(217, 107, 24, 0.12);
	border-radius: 12px 20px 10px 18px / 18px 10px 20px 12px;
	padding: 16px 24px;
	box-shadow: 0 4px 18px rgba(80, 40, 15, 0.08);
	backdrop-filter: blur(2px);
}

.guide-main-text {
	font-size: 18px;
	color: #4a2e1b;
	/* 深暖棕 */
	letter-spacing: 1.5px;
	margin: 0 0 10px 0;
	font-weight: 600;
}

.swipe-hint-box {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	padding: 9px 20px;
	border-radius: 50px;
	background: rgba(224, 211, 211, 0.6);
	/* 半透明暖白胶囊 */
	border: 1px solid rgba(180, 100, 30, 0.25);
	box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.swipe-finger {
	font-size: 15px;
	animation: nudgeLeft 1.5s ease-in-out infinite;
}

.guide-sub-text {
	font-size: 14px;
	font-weight: 700;
	color: #b85006;
	/* 深火红/暖橙色 */
	letter-spacing: 1px;
	text-shadow: -1.5px -1.5px 0 #fff, 1.5px -1.5px 0 #fff, -1.5px 1.5px 0 #fff,
		1.5px 1.5px 0 #fff;
}

/* 背景柔光球 */
.ambient-glow-ball {
	position: absolute;
	width: 220px;
	height: 220px;
	right: -70px;
	bottom: 15%;
	background: radial-gradient(circle,
			rgba(240, 180, 100, 0.2),
			transparent 70%);
	border-radius: 50%;
	z-index: 1;
	pointer-events: none;
}

/* --- 动画 --- */
@keyframes fadeInDown {
	from {
		opacity: 0;
		transform: translateY(-15px);
	}

	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.slide-in-1 {
	animation: fadeInBlur 0.8s cubic-bezier(0.16, 1, 0.3, 1) both;
}

.slide-in-2 {
	animation: fadeInBlur 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.2s both;
}

.fade-in-up {
	animation: fadeInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.4s both;
}

@keyframes fadeInBlur {
	from {
		opacity: 0;
		transform: translateY(12px);
		filter: blur(4px);
	}

	to {
		opacity: 1;
		transform: translateY(0);
		filter: blur(0);
	}
}

@keyframes fadeInUp {
	from {
		opacity: 0;
		transform: translateY(15px);
	}

	to {
		opacity: 1;
		transform: translateY(0);
	}
}

@keyframes wave {

	0%,
	100% {
		transform: rotate(0deg);
	}

	10%,
	30% {
		transform: rotate(-12deg);
	}

	20%,
	40% {
		transform: rotate(14deg);
	}

	50% {
		transform: rotate(0deg);
	}
}

@keyframes nudgeLeft {

	0%,
	100% {
		transform: translateX(0);
		opacity: 0.9;
	}

	50% {
		transform: translateX(-6px);
		opacity: 0.4;
	}
}

/* 手机矮屏幕适配 */
@media screen and (max-height: 670px) {
	.welcome-text {
		font-size: 23px;
	}

	.user-name-gradient {
		font-size: 26px;
	}

	.story-body-flow {
		gap: 20px;
		margin-top: 22px;
	}

	.story-line {
		font-size: 16px;
		line-height: 1.75;
	}

	.strong-dark {
		font-size: 17px;
	}

	.guide-main-text {
		font-size: 15px;
	}

	.guide-sub-text {
		font-size: 16px;
	}
}

/* PC端适配 */
@media screen and (min-width: 786px) {
	.report-container {
		background: url("../../assets/26June/logo.png") right top no-repeat,
			url("../../assets/26October/pcbg.png") no-repeat center / cover;
		background-size: 110px 35px, cover;
		width: 100% !important;
		height: 100vh !important;
		padding: 60px 10%;
		border-radius: 0 !important;
		box-shadow: none !important;
		border: none !important;
	}

	.highlight-time {
		font-size: 28px;
		color: #dc7234;
		font-weight: 700;
	}

	.content-main {
		max-width: 600px;
		margin: 0 auto;
		width: 100%;
		padding: 60px 0;
	}

	.welcome-text {
		font-size: 36px;
	}

	.user-name-gradient {
		font-size: 40px;
	}

	.story-body-flow {
		gap: 44px;
	}

	.story-line {
		font-size: 20px;
		line-height: 2;
	}

	.strong-dark {
		font-size: 22px;
	}

	.guide-main-text {
		font-size: 15px;
	}

	.guide-sub-text {
		font-size: 15px;
	}

	.ambient-glow-ball {
		width: 360px;
		height: 360px;
		right: 6%;
		bottom: 12%;
	}
}
</style>